import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/duplicates/translation.semantic.mutation.gql"
import type {
  TranslationSemanticMutation,
  TranslationSemanticMutationVariables,
} from "@/v2-backoffice-client/translation/duplicates/__types__/translation.semantic.mutation"

type Options = MutationHookOptions<
  TranslationSemanticMutation,
  TranslationSemanticMutationVariables
>

export function useTranslationSemanticMutation(options?: Options) {
  return useMutation<
    TranslationSemanticMutation,
    TranslationSemanticMutationVariables
  >(mutation, options)
}
